module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "description"
  }, [(_vm.secFlag === 0) ? _c('span', [_vm._v("距活动开始：")]) : (_vm.secFlag === 1 && _vm.timeNotLimited) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("正在抢购中")]) : _c('span', [_vm._v("距活动结束：")])]), _vm._v(" "), _c('span', {
    staticClass: "countdown"
  }, [(_vm.secFlag === 0 && _vm.daysOnly) ? _c('span', {
    staticClass: "clock"
  }, [_c('s', {
    staticClass: "hand hand-h"
  }, [_c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.day[0]))]), _vm._v(" "), _c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.day[1]))])]), _vm._v("天\n    ")]) : (_vm.secFlag === 1 && _vm.timeNotLimited) ? _c('span', {
    staticClass: "clock"
  }) : _c('span', {
    staticClass: "clock"
  }, [_c('s', {
    staticClass: "hand hand-h"
  }, [_c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.hr[0]))]), _vm._v(" "), _c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.hr[1]))])]), _vm._v(":\n      "), _c('s', {
    staticClass: "hand hand-m"
  }, [_c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.min[0]))]), _vm._v(" "), _c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.min[1]))])]), _vm._v(":\n      "), _c('s', {
    staticClass: "hand hand-s"
  }, [_c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.sec[0]))]), _vm._v(" "), _c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.sec[1]))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80195964","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Countdown.vue
// module id = 1684
// module chunks = 8